/* eslint-disable no-fallthrough */
/* eslint-disable no-case-declarations */
import { Toast } from "vant";
import { gotoauth } from './fetch';
// import * as Sentry from "@sentry/vue";
Toast.allowMultiple();

// 针对接口状态进行处理
const mapUrlCodeMsg = {
  send_verify_code: {
    10006: '请求太频繁，稍后再试'
  },
  verify: {
    10005: '验证码错误或已失效'
  },
  submit: {
    10005: '表单不存在',
    10006: '抱歉，已超过限制提交数量',
    10007: '表单未开启',
    10008: '抱歉，现在未到填写时间',
    10009: '您已经提交表单，不能重复提交'
  },
  modify: {
    10005: '表单或提交记录不存在',
    10006: '抱歉，该表单不允许修改',
    10007: '表单未开启',
    10008: '抱歉，现在未到填写时间'
  },
  check_submit: {
    10005: '您尚未提交过'
  },
  get_preview_form_detail: {
    10005: '预览表单不存在或已过期'
  },
  get_form_config: {
    10005: '表单不存在'
  },
  get_submit_detail: {
    10005: '提交记录不存在'
  },
};
/**
 * 检查 err_code
 */
export const checkCode = ({ res, url, method, params, notips }) => {
  // debug
  // res = {
  //   data: {},
  //   err_code: 10004,
  //   err_msg: 'test error'
  // }
  return new Promise((resolve, reject) => {
    if (res.err_code === 0) {
      resolve(res.data); 
    }
    else if (res.err_code === 10002) {
      !notips && Toast({
        message: "自动登录中",
        duration: 3000,
      });
      gotoauth();
      reject(res);
    }
    else if (res.err_code === 10003) {
      !notips && Toast({
        message: `参数错误，${res.err_msg}`,
        duration: 3000,
      });
      reject(res);
    }
    else if (res.err_code === 10004) {
      !notips && Toast({
        message: `数据库错误`,
        duration: 3000,
      });
      reject(res);
    }
    else {
      let errMsg = "";
      if (mapUrlCodeMsg[url] && mapUrlCodeMsg[url][res.err_code]) {
        errMsg = mapUrlCodeMsg[url][res.err_code];
      }
      if (errMsg) {
        !notips && Toast({
          message: errMsg,
          duration: 3000,
        });
      } else {
        !notips && Toast({
          message: `${res.err_msg}(${res.err_code})`,
          duration: 3000,
        });
        const logObj = {
          url,
          method,
          params,
          res,
          href: window.location.href
        };
        // 对未经处理的err_code，进行sentry上报
        // Sentry.withScope((scope) => {
        //   scope.setExtra("payload", logObj);
        //   Sentry.captureException(
        //     new Error(`【未捕获的err_code: ${res.err_code}】${url}`)
        //   );
        // });
      }
      reject(res);
    }
  });
};
